export const sourceDonutLegends = [
  {
    label: "Campus campaign",
    color: "#17A3A0",
  },
  {
    label: "Company website",
    color: "#E0726C",
  },
  {
    label: "Employees referral",
    color: "#f8bc6c",
  },
  {
    label: "Naukri",
    color: "#656565",
  },
  {
    label: "Indeed",
    color: "#C175D4",
  },
  {
    label: "LinkedIn",
    color: "#C1D685",
  },
  {
    label: "Recruitment Agency",
    color: "#9D96E8",
  },
  {
    label: "Others",
    color: "#538EC9",
  },
  {
    label: "Northstarz.ai",
    color: "#1D2A3D",
  },
];

export const defaultDepartment = { value: "", label: "All Departments" };
export const defaultManagers = { value: "", label: "All Hiring Managers" };

export const SortByValue = {
  WEEK: "week",
  MONTH: "month",
  CURRENT_MONTH: "currentMonth",
  LAST_MONTH: "lastMonth",
  LAST_90_DAYS: "last90Days",
  YEAR_TO_DATE: "yearToDate",
};

export const sortByOptions = [
  { label: "Last 7 days", value: SortByValue.WEEK },
  { label: "Last 30 days", value: SortByValue.MONTH },
  { label: "Current Month", value: SortByValue.CURRENT_MONTH },
  { label: "Last Month", value: SortByValue.LAST_MONTH },
  { label: "Last 90 Days", value: SortByValue.LAST_90_DAYS },
  { label: "Year to Date", value: SortByValue.YEAR_TO_DATE },
];

export const MONTHS_ARRAY = (() => {
  const months = [];
  const currentDate = new Date();

  for (let i = 5; i >= 0; i--) {
    const date = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - i,
      1,
    );
    const monthName = date.toLocaleString("default", { month: "short" });
    months.push(monthName);
  }
  return months;
})();

// Last 6 months in "YYYY-MM" (local time). Used only by HiringPerformance chart to align with backend month keys.
export const MONTHS_FOR_DATA_ARRAY = (() => {
  const monthsForData = [];
  const currentDate = new Date();

  for (let i = 5; i >= 0; i--) {
    const date = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - i,
      1,
    );
    // Use local YYYY-MM so backend month keys (e.g. 2026-02) match; toISOString() uses UTC and can shift month.
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    monthsForData.push(`${y}-${m}`);
  }
  return monthsForData;
})();
